import { ChangeEvent, useRef } from 'react';

import { Controller, useFormContext } from 'react-hook-form';
import { FiUpload, FiX } from 'react-icons/fi';
import toast from 'react-hot-toast';

import Button from '@components/Button';

import * as S from '../styles';
import { FieldRendererProps } from '../types';

const FileField = ({ field, disabled }: FieldRendererProps) => {
  const { control } = useFormContext();
  const inputRef = useRef<HTMLInputElement>(null);

  const handleClick = () => {
    inputRef.current?.click();
  };

  return (
    <Controller
      name={field.name}
      control={control}
      defaultValue={null}
      render={({ field: formField }) => {
        const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
          const file = e.target.files?.[0];
          if (file) {
            // Check file size if max_size is specified (in KB)
            if (field.max_size && file.size > field.max_size * 1024) {
              toast.error(`Arquivo muito grande. Máximo: ${field.max_size}KB`);
              return;
            }
            formField.onChange(file);
          }
        };

        const handleRemove = () => {
          formField.onChange(null);
          if (inputRef.current) {
            inputRef.current.value = '';
          }
        };

        return (
          <S.FileInputWrapper>
            <input
              ref={inputRef}
              type="file"
              accept={field.accept}
              onChange={handleFileChange}
              disabled={disabled}
              style={{ display: 'none' }}
            />

            {formField.value ? (
              <S.FilePreview>
                <span>{(formField.value as File).name}</span>
                <Button
                  type="button"
                  variant="transparent"
                  size="even"
                  icon={<FiX />}
                  onClick={handleRemove}
                  disabled={disabled}
                />
              </S.FilePreview>
            ) : (
              <Button
                type="button"
                variant="outline"
                icon={<FiUpload />}
                title={field.placeholder || 'Selecionar arquivo'}
                onClick={handleClick}
                disabled={disabled}
              />
            )}

            {field.help_text && <S.HelpText>{field.help_text}</S.HelpText>}
          </S.FileInputWrapper>
        );
      }}
    />
  );
};

export default FileField;
